/* ==========================================================
   image-slot — Lightweight image placeholder web component.
   Usage: <image-slot placeholder="Label" width="400" height="300" radius="6"></image-slot>
   ========================================================== */
customElements.define('image-slot', class extends HTMLElement {
  connectedCallback() {
    var w  = this.getAttribute('width')       || '100%';
    var h  = this.getAttribute('height')      || '100%';
    var r  = this.getAttribute('radius')      || '0';
    var lbl = this.getAttribute('placeholder') || 'Image';
    this.style.cssText =
      'display:flex;align-items:center;justify-content:center;flex-direction:column;gap:8px;' +
      'width:' + w + ';height:' + h + ';' +
      'background:#F3F3F4;border-radius:' + r + 'px;' +
      'color:#8B8C8F;font-family:inherit;';
    this.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" style="opacity:.5">' +
        '<rect x="3" y="3" width="18" height="18" rx="2"/>' +
        '<circle cx="8.5" cy="8.5" r="1.5"/>' +
        '<polyline points="21 15 16 10 5 21"/>' +
      '</svg>' +
      '<span style="font-size:10px;letter-spacing:.14em;text-transform:uppercase;opacity:.6">' + lbl + '</span>';
  }
});
